import {hasPermission} from "../../services/permission"

export type ActionButtons = Array<"Reject" | "Approve" | "Return" | "Clear" | "Cancel"> | null

// Maps each button to its required permission resource and action
const buttonPermissionMap: Record<string, {resource: string; action: string}> = {
	Approve: {resource: "checkDeposit.approve", action: "update"},
	Reject: {resource: "checkDeposit.reject", action: "update"},
	Clear: {resource: "checkDeposit.clear", action: "update"},
	Return: {resource: "checkDeposit.return", action: "update"},
	Cancel: {resource: "checkDeposit.cancel", action: "update"},
}

export const getPermittedButtons = (buttons: ActionButtons, isOrgAdmin: boolean): ActionButtons => {
	if (!buttons) return null

	const permittedButtons = buttons.filter((button) => {
		const permission = buttonPermissionMap[button]
		if (!permission) return false
		if ((button === "Cancel" || button === "Clear") && isOrgAdmin) {
			return true
		}
		return hasPermission(permission.resource, permission.action)
	})

	return permittedButtons.length > 0 ? permittedButtons : null
}

export const hasAnyCheckDepositPermission = (buttons: ActionButtons, isOrgAdmin: boolean): boolean => {
	if (!buttons) return false

	return buttons.some((button) => {
		const permission = buttonPermissionMap[button]
		if (!permission) return false
		if ((button === "Cancel" || button === "Clear") && isOrgAdmin) {
			return true
		}
		return hasPermission(permission.resource, permission.action)
	})
}
